import Icon, { IconName } from "components/ui/Icon";
import { Heading } from "components/ui/Text";
import UILabel from "components/ui/UILabel";
import React, { forwardRef, useImperativeHandle, useRef } from "react";
import Modal, { ModalApi } from "../Modal";
import * as Styled from "./styled";

const LINE_ITEMS: { icon: IconName; title: string; body: string[] }[] = [
  {
    icon: "plus",
    title: "Money coming in",
    body: ["50% accrued net earnings"],
  },
  {
    icon: "plus",
    title: "Money you already have",
    body: ["Checking balance"],
  },
  {
    icon: "minus",
    title: "Money leaving shortly",
    body: ["Upcoming bills", "Savings goals", "Investment goals"],
  },
];

const SpendingPowerModal = (
  _props,
  forwardedRef: React.ForwardedRef<unknown>
) => {
  const ref = useRef<ModalApi>(null);

  useImperativeHandle(forwardedRef, () => ref.current);

  return (
    <Modal ref={ref}>
      <Styled.Wrapper>
        <Styled.Header>
          <Heading.H4>Card spending power</Heading.H4>
          <Styled.Subheading>
            A single, intelligent number keeps you informed and in control.
          </Styled.Subheading>
        </Styled.Header>

        <Styled.List>
          {LINE_ITEMS.map((item) => (
            <Styled.ListItem key={item.title}>
              <Styled.IconWrapper $icon={item.icon}>
                <Icon name={item.icon} size="md" />
              </Styled.IconWrapper>

              <Styled.ItemText>
                <UILabel.Micro bold wideCaps color="primary">
                  {item.title}
                </UILabel.Micro>
                <Styled.ItemBody>
                  {item.body.map((text) => (
                    <UILabel.XLarge key={text}>{text}</UILabel.XLarge>
                  ))}
                </Styled.ItemBody>
              </Styled.ItemText>
            </Styled.ListItem>
          ))}

          <Styled.Divider />

          <Styled.ListItem>
            <Styled.IconWrapper $icon="equals">
              <Icon name="equals" size="md" />
            </Styled.IconWrapper>

            <Styled.ItemText>
              <UILabel.Micro bold wideCaps color="primary">
                Safe to spend
              </UILabel.Micro>
              <Styled.ItemBody>
                <UILabel.XLarge>Card spending power</UILabel.XLarge>
              </Styled.ItemBody>
            </Styled.ItemText>
          </Styled.ListItem>
        </Styled.List>
      </Styled.Wrapper>
    </Modal>
  );
};

export default forwardRef(SpendingPowerModal);
